export default __webpack_public_path__ + "5970a5882fd26c7c7d79253638b1444d.gif";